import { render, staticRenderFns } from "./smsRecordTable.vue?vue&type=template&id=5a3c1fd8&scoped=true"
import script from "./smsRecordTable.vue?vue&type=script&lang=js"
export * from "./smsRecordTable.vue?vue&type=script&lang=js"
import style0 from "./smsRecordTable.vue?vue&type=style&index=0&id=5a3c1fd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3c1fd8",
  null
  
)

export default component.exports